/// <reference path="../List/FormatLookupEditor.ts" />

namespace Matrix.Data {

    @Serenity.Decorators.registerEditor()
    export class ViewLookupEditor extends Serenity.LookupEditorBase<ViewLookupEditorOptions, any> {

        constructor(input: JQuery, opt: ViewLookupEditorOptions) {
            super(input, opt);
        }

        protected getLookupKey() {
            return "ViewLookup." + this.options.viewName;
        }
    }

    export interface ViewLookupEditorOptions extends Serenity.LookupEditorOptions {
        viewName: string;

    }
}